var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "skpfull_wrap", attrs: { id: "wrap" } }, [
    _c("div", { staticClass: "msg_box" }, [
      _vm.pageMode == "UC"
        ? _c("p", [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "link",
                attrs: {
                  href: "https://www.samsung.com/",
                  title: "Go to Samsung.com Home"
                }
              },
              [_vm._v("Go to Samsung.com Home")]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.pageMode == "PO"
        ? _c("p", [
            _c("em", [
              _c("i", [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("MESSAGE.EUR.MOBILE.UC1"))
                ),
                _c("br"),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("MESSAGE.EUR.MOBILE.UC2"))
                ),
                _c("br")
              ])
            ])
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("em", [
      _vm._v("\n                System stabilization is in progress."),
      _c("br"),
      _vm._v("\n                Please wait a moment. \n            ")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1e37cef9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e37cef9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/eur/UnderConstr.vue
// module id = /clH
// module chunks = 0